<template>
    <div class="bg-grow-light pt-8 pb-16">
        <LayoutsSectionRegularTemplate>
            <template #icon>
                <MarketingIcon class="w-12 mx-auto" />
            </template>
            <template #title>
                <span v-html="dataLocale.data.title"></span>
            </template>
            <template #content>
                <div class="grid grid-cols-12 xs:gap-8 md:px-4 h-full">
                    <div class="col-span-12 md:col-span-6 lg:col-span-4 max-w-full xs:h-full xs:mb-0 mb-6" v-for="be in benefits">
                        <div class="rounded-xl xs:h-full bg-white drop-shadow-lg p-4 xs:p-6">
                            <div class="flex items-center justify-center mb-4">
                                <nuxt-img loading="lazy" :src="'/benefit/' + be.icon" format="webp" :alt="be.title" :width="100" />
                            </div>
                            <h3 class="text-xl md:text-2xl text-center py-2 font-matter font-tinybold">
                                {{ be.title }}
                            </h3>
                            <p class="text-base md:text-lg">
                                {{ be.description }}
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </LayoutsSectionRegularTemplate>
    </div>
</template>
<script lang="ts" setup>
import MarketingIcon from "~/assets/svg/marketing.svg?component"
import DataLocale from "~~/config/interface/DataLocale";
import BefinitLocale from "~~/config/widgets/benefit-widget";
const benefits = (new BefinitLocale).data
const dataLocale = new DataLocale([
    {
        locale: "en",
        title: 'What We Do for your <span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">Success</span> ?'
    },
    {
        "locale": "vi",
        "title": 'Chúng tôi giúp gì cho <span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">Thành công</span> của bạn?'
    },
    {
        "locale": "de",
        "title": 'Was wir für Ihren <span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">Erfolg</span> tun?'
    },
    {
        "locale": "fr",
        "title": 'Que faisons-nous pour votre <span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">Succès</span> ?'
    },
    {
        "locale": "es",
        "title": '¿Qué hacemos para tu <span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">Éxito</span> ?'
    },
    {
        "locale": "it",
        "title": 'Cosa facciamo per il tuo <span class="down- mark - line text - 3xl md: text - 5xl lg: text - 6xl">Successo</span> ?'
    },
    {
        "locale": "ja",
        "title": '<span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">成功</span> のために私たちは何をするのか？'
    },
    {
        "locale": "zh",
        "title": '我们为您的<span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">成功</span>做什么？'
    }, 
    {
        "locale": "pt",
        "title": 'O que fazemos para o seu <span class="down-mark-line text-3xl md:text-5xl lg:text-6xl">Sucesso</span> ?'
    }
])
</script>